import PageTitle from "../components/PageTitle";
import { BsXCircleFill, BsCheck } from "react-icons/bs";
import Button from "../components/Button";
import { useState } from "react";

export default function ShoppingCart() {
  return (
    <>
      <PageTitle title="Shop Cart" path={["Pages ", "Shop Cart"]} />
      {/* container */}
      <div className="flex justify-between max-w-5xl mx-auto font-fontOne mt-16">
        {/* col 1 */}
        <div className="w-8/12 p-4">
          {/* header */}
          <div className=" flex mb-10">
            <div className=" w-6/12">
              <HeaderLabel>Product</HeaderLabel>
            </div>
            <div className=" w-2/12">
              <HeaderLabel>Price</HeaderLabel>
            </div>
            <div className=" w-2/12 ">
              <HeaderLabel>Quantity</HeaderLabel>
            </div>
            <div className=" w-2/12 ">
              <HeaderLabel>Total</HeaderLabel>
            </div>
          </div>
          {/* list */}
          <ListElement img={require("../assets/shopping-cart/img01.png")} />
          <ListElement img={require("../assets/shopping-cart/img02.png")} />
          <ListElement img={require("../assets/shopping-cart/img03.png")} />
          <ListElement img={require("../assets/shopping-cart/img04.png")} />
          <ListElement img={require("../assets/shopping-cart/img05.png")} />
          <div className="flex justify-between mt-8">
            <Button color={"pink"}>Update Cart</Button>
            <Button color={"pink"}>Clear Cart</Button>
          </div>
        </div>
        {/* col 2 */}
        <div className="w-4/12 p-4 font-fontTwo">
          <HeaderLabel className={"text-center mb-10"}>Cart Totals</HeaderLabel>
          <div className="w-full bg-[#F4F4FC] py-6 px-5">
            <div className=" mb-6 pb-2 border-b-2 flex justify-between rounded-sm border-[#E8E6F1]">
              <div>Subtotals</div>
              <div>$219.00</div>
            </div>
            <div className=" mb-6 pb-2 border-b-2 flex justify-between rounded-sm border-[#E8E6F1]">
              <div>Subtotals</div>
              <div>$219.00</div>
            </div>
            <GreenCheckBox>
              Shipping & taxes calculated at checkout
            </GreenCheckBox>
            <Button color="green" className="text-sm w-full mt-5">
              Proceed To Checkout
            </Button>
          </div>
          <HeaderLabel className={"text-center my-10"}>
            Calculate Shipping
          </HeaderLabel>
          <div className="w-full bg-[#F4F4FC] py-6 px-5">
            <div className=" mb-6 pb-2 border-b-2 flex justify-between rounded-sm border-[#E8E6F1]">
              <input
                type="text"
                className="w-full bg-transparent focus:outline-none"
                placeholder="Kurdistan"
              />
            </div>
            <div className=" mb-6 pb-2 border-b-2 flex justify-between rounded-sm border-[#E8E6F1]">
              <input
                type="text"
                className="w-full bg-transparent focus:outline-none"
                placeholder="Duhok"
              />
            </div>
            <div className=" mb-6 pb-2 border-b-2 flex justify-between rounded-sm border-[#E8E6F1]">
              <input
                type="text"
                className="w-full bg-transparent focus:outline-none"
                placeholder="Zip Code"
              />
            </div>
            <Button color="pink">Calculate Shipping</Button>
          </div>
        </div>
      </div>
    </>
  );
}

function HeaderLabel({ children, className }) {
  return (
    <div className={`${className} font-bold text-lg font-fontOne`}>
      {children}
    </div>
  );
}

function ListElement({ img }) {
  return (
    <div className=" w-full flex font-semibold items-center border-b py-3">
      {/* image and name */}
      <div className=" w-6/12 flex">
        {/* image contianer */}
        <div className=" mr-2 relative max-w-24 flex-center">
          <button className="absolute -top-2 -right-2">
            <BsXCircleFill />
          </button>
          <img alt="" src={img} />
        </div>
        <div>
          <h2 className=" text-xl font-bold">Sko siemak keoh</h2>
          <div className=" text-sub_text_color font-normal">Color: Brown</div>
          <div className=" text-sub_text_color font-normal">Size: XL</div>
        </div>
      </div>
      {/* Price */}
      <div className=" w-2/12 ">$32.00</div>
      {/* Quantity */}
      <div className=" w-2/12">
        <input
          type="number"
          className="w-10 pl-1  focus:outline-none bg-[#E7E7EF]"
          placeholder="1"
          min={1}
        />
      </div>
      {/* Total */}
      <div className=" w-2/12">$50.00</div>
    </div>
  );
}

function GreenCheckBox({ children }) {
  const [checked, setChecked] = useState();
  return (
    <label className="flex items-center mb-2 text-sm">
      <div className="relative w-3 h-3 mr-2 p-0 -translate-y-[2px]">
        <input
          className={`${
            checked ? " bg-green" : "bg-white"
          } appearance-none rounded-lg h-full w-full `}
          type="checkbox"
          onChange={(e) => {
            setChecked(e.target.checked);
          }}
        />
        <BsCheck
          className="absolute top-[1px] -left-[0.5px] "
          size={15}
          color={checked ? "white" : "#19D16F"}
        />
      </div>
      {children}
    </label>
  );
}
